import {
  listPayouts as publicListPayouts,
  getPayout as publicGetPayout,
} from './payments-payouts-v4-payout-payouts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onPayoutCreated as publicOnPayoutCreated } from './payments-payouts-v4-payout-payouts.public.js';
import { onPayoutUpdated as publicOnPayoutUpdated } from './payments-payouts-v4-payout-payouts.public.js';

export const listPayouts: MaybeContext<
  BuildRESTFunction<typeof publicListPayouts> & typeof publicListPayouts
> = /*#__PURE__*/ createRESTModule(publicListPayouts);
export const getPayout: MaybeContext<
  BuildRESTFunction<typeof publicGetPayout> & typeof publicGetPayout
> = /*#__PURE__*/ createRESTModule(publicGetPayout);
/**
 * Triggered when a payout is created.
 *
 * The payout is created before the underlying transfer is initiated at the
 * bank. At this point `status` is `SENT` and `estimatedArrivalDateV2` is set
 * if the bank rail returned one. `failureReason` and `bankTransferReference`
 * are not yet populated.
 */
export const onPayoutCreated: BuildEventDefinition<
  typeof publicOnPayoutCreated
> &
  typeof publicOnPayoutCreated = /*#__PURE__*/ createEventModule(
  publicOnPayoutCreated
);
/**
 * Triggered when a payout is updated.
 *
 * Typical updates include `status` transitioning from `SENT` to `FAILED`
 * (with `failureReason` being set), `estimatedArrivalDateV2` being refined by
 * the bank rail, and `bankTransferReference` being populated once the rail
 * returns it.
 */
export const onPayoutUpdated: BuildEventDefinition<
  typeof publicOnPayoutUpdated
> &
  typeof publicOnPayoutUpdated = /*#__PURE__*/ createEventModule(
  publicOnPayoutUpdated
);

export {
  PayoutStatus,
  PayoutFailureCode,
  SortOrder,
  WebhookIdentityType,
} from './payments-payouts-v4-payout-payouts.universal.js';
export {
  Payout,
  Money,
  PayoutFailureReason,
  ListPayoutsRequest,
  Sorting,
  AddressLocation,
  Paging,
  ListPayoutsResponse,
  PagingMetadata,
  CreatePayoutRequest,
  CreatePayoutResponse,
  GetPayoutRequest,
  GetPayoutResponse,
  ListPayoutGroupsRequest,
  ListPayoutGroupsResponse,
  PayoutGroup,
  GetPayoutGroupRequest,
  GetPayoutGroupResponse,
  GetPayoutGroupByPayoutIdRequest,
  GetPayoutGroupByPayoutIdResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  PayoutCreatedEnvelope,
  PayoutUpdatedEnvelope,
  ListPayoutsOptions,
} from './payments-payouts-v4-payout-payouts.universal.js';
export {
  PayoutStatusWithLiterals,
  PayoutFailureCodeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './payments-payouts-v4-payout-payouts.universal.js';
